import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.CUSTOMERS}/Locations`;

export function getLocationCoordinates(field, item) {
  if (field.includes("start"))
    return getLatitudeStart(item) + "," + getLongitudeStart(item);
  else if (field.includes("end"))
    return getLatitudeEnd(item) + "," + getLongitudeEnd(item);
  else return getLatitude(item) + "," + getLongitude(item);
}

function getLatitudeStart(item) {
  return item.latStart || item.startLatitude;
}

function getLongitudeStart(item) {
  return item.lonStart || item.startLongitude;
}

function getLatitudeEnd(item) {
  return item.latEnd || item.endLatitude;
}

function getLongitudeEnd(item) {
  return item.lonEnd || item.endLongitude;
}

function getLatitude(item) {
  return item.latitude;
}

function getLongitude(item) {
  return item.longitude;
}

async function searchByCep(payload) {
  try {
    let response = await api.get(`${basePath}`, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(
      response,
      "clientService.search"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "clientService.search");
    return null;
  }
}

async function searchByAddress(address) {
  try {
    let response = await api.get(`${basePath}/coordinates?address=${address}`);

    let treated = errorHandling.handleResponse(
      response,
      "locationsService.searchByAddress"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "locationsService.searchByAddress");
    return null;
  }
}

async function fetchCoordinates(address) {
  try {
    const encodedAddress = encodeURIComponent(address);
    let response = await api.get(`${basePath}/coordinates?address=${encodedAddress}`);

    let treated = errorHandling.handleResponse(
      response,
      "locationsService.fetchCoordinates"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "locationsService.fetchCoordinates");
    return null;
  }
}



export const locationsService = {
  searchByCep,
  searchByAddress,
  fetchCoordinates
};
